import Button from 'components/_UI/Button';
import Text from 'components/_UI/Text';
import React from 'react'
import styled from 'styled-components'
import { FullyCentered } from 'styled/alignment/Center'
import { Column } from 'styled/alignment/Column';
import { Row } from 'styled/alignment/Row';
import colors from 'theme/colors';
import sizes from 'theme/sizes';

export default function Profile() {
    return (
        <ProfileContainer>
            <UserInfoContainer>
                <UserImageContainer>
                    <UserImage src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRHC1G7Fb6ufjKySnzkC2XoUwshtunDkIgdHeKxrCQPfIk8xyUqfskIwysJh6kHEWKKx1k&usqp=CAU' />
                </UserImageContainer>

                <UserInfo>
                    <Text name='title' color={colors.nightDark}>Patrick Porto</Text>
                    <Text
                        name='default'
                        color={colors.nightLight}
                        marginTop={'-10px'}>
                        @patrick.porto
                    </Text>
                    <Text
                        color={colors.nightDark}
                        marginTop={'16px'}
                    >
                        Gordão do quartier, jogador de padel por profissão e fazedor de telinhas por amor.
                    </Text>
                </UserInfo>

                <StatisticsInfo>
                    <Column>
                        <Text name='highlight'>17</Text>
                        <Text name='default'>Eventos</Text>
                    </Column>

                    <Column>
                        <Text name='highlight'>400</Text>
                        <Text name='default'>Seguidores</Text>
                    </Column>

                    <Column>
                        <Text name='highlight'>124</Text>
                        <Text name='default'>Seguindo</Text>
                    </Column>
                </StatisticsInfo>

                <ButtonContainer>
                    <Button
                        category='squiredBorded'
                        variant='light'
                        size='small'
                    >
                        Editar perfil
                    </Button>
                </ButtonContainer>
            </UserInfoContainer>
        </ProfileContainer>
    )
}

const ProfileContainer = styled(Column)`
    background: ${colors.nightLight};
`;

const UserInfoContainer = styled(FullyCentered)`
    background: ${colors.neutralLight};
    padding: 50px 15%;
    flex-direction: column;
    border-radius: ${sizes.none} ${sizes.none} ${sizes.tiny} ${sizes.tiny} ;
`;

const UserImageContainer = styled.div`
    width: 104px;
    height: 104px;
`;

const UserImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
`;

const UserInfo = styled(Column)`
    margin-top: 26px;
    align-items: center;
    justify-content: center;
    text-align: center;
`;

const StatisticsInfo = styled(Row)`
    margin-top: 24px;
    width: 100%;
    justify-content: space-between;
    text-align: center;
`;

const ButtonContainer = styled.div`
    width: 106px;
    margin-top: 20px;
    height: 16px;
    
    & > button {
        text-transform: capitalize;
        padding: 8px 2px !important;
    }
`